export enum ContactInformationSimpleField {
  firstName = 'firstName',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  email = 'email',
}
